// css =>
import "../../BaseStructure.css";
import Styled from "./NotFound.module.css";

function NotFound() {
    return(
        <div className="row" id={ Styled.NotFoundSectionBox }>
            <div className="col-12">
                <h1>صحفه مورد نظر یافت نشد!</h1>
            </div>
        </div>
    );
}

export default NotFound;
